import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.charts');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-charts',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.charts/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAdminChartsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public charts: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public source: string = '';
    public songs: any[] = [];
    public loading: boolean = false;
    public busyAction: string = '';

    public editing: any = null;
    public showEditor: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.loadSongs();
        await this.load();
    }

    public async loadSongs() {
        let { code, data } = await wiz.call("songs");
        if (code === 200) this.songs = data.songs || [];
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        try {
            let { code, data } = await wiz.call("list", { page: this.page, dump: 20, source: this.source });
            if (code === 200) {
                this.charts = data.charts || [];
                this.total = data.total || 0;
            }
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async search() { this.page = 1; await this.load(); }

    public songTitle(songId: string) {
        let s = this.songs.find(x => x.id === songId);
        return s ? `${s.title_ko} - ${s.artist_name}` : songId;
    }

    public newChart() {
        if (this.busyAction) return;
        this.editing = { source: 'tj_top100', song_id: '', rank: 1, snapshot_date: new Date().toISOString().slice(0, 10) };
        this.showEditor = true;
        this.service.render();
    }

    public editChart(item: any) {
        if (this.busyAction) return;
        this.editing = { ...item };
        this.showEditor = true;
        this.service.render();
    }

    public async saveChart() {
        if (this.busyAction) return;
        if (!this.editing.song_id || !this.editing.source) {
            await this.service.modal.error("필수 항목을 입력해주세요.");
            return;
        }
        this.busyAction = 'save';
        await this.service.render();
        try {
            let { code, data } = await wiz.call("save", this.editing);
            if (code === 200) {
                this.showEditor = false;
                await this.load();
            } else {
                await this.service.modal.error(data?.message || "저장 실패");
            }
        } finally {
            this.busyAction = '';
            await this.service.render();
        }
    }

    public async deleteChart(item: any) {
        if (this.busyAction) return;
        let res = await this.service.modal.show({
            title: '차트 삭제', message: '이 차트 항목을 삭제하시겠습니까?',
            action: '삭제', cancel: '취소', status: 'error', actionBtn: 'error'
        });
        if (!res) return;
        this.busyAction = 'delete:' + item.id;
        await this.service.render();
        try {
            let { code, data } = await wiz.call("delete", { id: item.id });
            if (code === 200) {
                await this.load();
            } else {
                await this.service.modal.error(data?.message || "삭제 실패");
            }
        } finally {
            this.busyAction = '';
            await this.service.render();
        }
    }

    public cancelEdit() { this.showEditor = false; this.service.render(); }

    public async recalculate() {
        if (this.busyAction) return;
        this.busyAction = 'recalculate';
        await this.service.render();
        try {
            let { code, data } = await wiz.call("recalculate");
            if (code === 200) {
                await this.service.modal.success("인기도 점수 재계산 완료");
            } else {
                await this.service.modal.error(data?.message || "재계산 실패");
            }
        } finally {
            this.busyAction = '';
            await this.service.render();
        }
    }
}

export default PageAdminChartsComponent;